/**
 * LanguageToggle · Botón compacto ES / EN para alternar el idioma de la UI.
 *
 * Persiste en localStorage (clave `valoriza_lang`) vía i18next detector.
 * Recarga inmediata sin refresh del navegador.
 */
import React from "react";
import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";

export default function LanguageToggle({ compact = false, className = "" }) {
  const { i18n, t } = useTranslation();
  const current = (i18n.language || "es").startsWith("en") ? "en" : "es";

  const toggle = () => {
    const next = current === "es" ? "en" : "es";
    i18n.changeLanguage(next);
  };

  return (
    <button
      onClick={toggle}
      title={t("language.toggleTooltip")}
      data-testid="language-toggle"
      className={`inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider rounded transition px-2.5 py-1.5 border ${
        compact
          ? "bg-white/10 hover:bg-white/20 text-white border-white/10"
          : "bg-white hover:bg-gray-50 text-gray-700 border-gray-200"
      } ${className}`}>
      <Globe size={12} />
      <span className={current === "es" ? "font-extrabold" : "opacity-50"}>ES</span>
      <span className="opacity-30">/</span>
      <span className={current === "en" ? "font-extrabold" : "opacity-50"}>EN</span>
    </button>
  );
}
